import React from 'react';
import './AnalysisList.scss';
import HeaderPrint from "../HeaderPrint/HeaderPrint";
import AnalysisListTable from "./AnalysisListTable";

const AnalysisList = ({data}) => {

  try {
    return (
      <>
        {data?.data?.data.map((item, index) => (
          <React.Fragment key={index}>
            <section className='analysis_list'>
              <HeaderPrint
                persianTitle={"فهرست تحلیل ها"}
                englishTitle={"Analysis list"}
                color={"#B70000"}
              />
              <div className='form_info'>
                <div className='info_box'>
                  <div className='box_child'>
                    <span className='iransans'>کاربـر :</span>
                    <span className='iransans'>{item.user}</span>
                  </div>
                </div>
                <div className='info_box'>
                  <div className='box_child'>
                    <span className='iransans'>تاریخ :</span>
                    <span className='iransans'>{item.date}</span>
                  </div>
                </div>
              </div>
              <AnalysisListTable tableData={item.table}/>
            </section>
            {index < data?.data?.data.length - 1 && (
              <div style={{pageBreakBefore: "always"}}></div>
            )}
          </React.Fragment>
        ))}
      </>
    );
  }catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default AnalysisList;